/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const DacCodes = {

	deleteDacCode (context, codeId, onSuccess, onError, options) {
		Api.delete(context,
			"/dac-codes/dac-code"
			+ "?codeId=" + codeId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, onSuccess, onError, options) {
		Api.get(context,
			"/dac-codes"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, code, desc, onSuccess, onError, options) {
		Api.post(context,
			"/dac-codes"
			+ "?code=" + code
			+ "&desc=" + desc
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putDacCode (context, codeId, code, description, onSuccess, onError, options) {
		Api.put(context,
			"/dac-codes/dac-code"
			+ "?codeId=" + codeId
			+ "&code=" + code
			+ "&description=" + description
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
